import React from 'react';
import 'classnames';
import '../../../rewards/Progress/index.js';
import '../../../rewards/RewardIcon/index.js';
import '../../../rewards/RewardIconWrapper/index.js';
import '../../../rewards/RewardsProgressBar/index.js';
import '../../../rewards/RewardStatus/index.js';
import '../../../rewards/VipIcon/index.js';
import '../../../rewards/InstantRakeback/index.js';
import '../../../rewards/Range/index.js';
import '../../../rewards/VipReload/index.js';
import '../../../rewards/RewardWallet/index.js';
import '../../../rewards/RewardHorizontal/index.js';
import '../../../rewards/RewardHorizontalV2/index.js';
import '../../../rewards/Reward/index.js';
import '../../../rewards/AvailableProgress/index.js';
import '../../../rewards/Benefits/index.js';
import '../../../rewards/CountDownBanner/index.js';
import '../../../rewards/ProgressWidget/index.js';
import '../../../rewards/RewardsSliderPreview/index.js';
import '../../../rewards/RewardsSlider/index.js';
import '../../../rewards/VipLevelLine/index.js';
import '../../../rewards/VipLevelAccordion/index.js';
import '../../../rewards/VipProgress/index.js';
import '../../../rewards/VipRewards/index.js';
import '../../../rewards/RewardsList/index.js';
import '../../../rewards/RewardTypeIcon/index.js';
import '../../../rewards/RewardsDropdown/RDContent/index.js';
import '../../../rewards/RewardsDropdown/RDFooter/index.js';
import '../../../rewards/RewardsDropdown/RDHeader/index.js';
import '../../../rewards/RewardsDropdown/RDList/index.js';
import '../../../rewards/RewardsDropdown/RDRow/index.js';
import '../../../rewards/RewardsDropdown/RDStatistic/index.js';
import '../../../rewards/RewardsDropdown/RDWrapper/index.js';
import { UserInfo } from '../../../user/UserInfo/index.js';
import '../../../user/AvatarName/index.js';
import '../../../user/UserName/index.js';
import '../../../user/UserCryptoLine/index.js';
import '../../../user/UserRainLine/index.js';
import '../../../user/UserInfoStat/index.js';
import '../../../user/UserInfoWrapper/index.js';
import '../../../../ui/accordions/Accordion/index.js';
import '../../../../ui/accordions/AccordionSelect/index.js';
import '../../../../ui/badges/Badge/index.js';
import '../../../../ui/badges/BadgeIcon/index.js';
import '../../../../ui/badges/Checked/index.js';
import '../../../../ui/badges/Panel/index.js';
import '../../../../ui/badges/Status/index.js';
import '../../../../ui/badges/Tag/index.js';
import '../../../../ui/buttons/BabyButton/Base.js';
import '../../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../../ui/buttons/Button/index.js';
import '../../../../ui/buttons/CloseButton/index.js';
import '../../../../ui/buttons/DirectionButton/index.js';
import { GradientButton } from '../../../../ui/buttons/GradientButton/index.js';
import '../../../../ui/buttons/GradientButtonV2/index.js';
import '../../../../ui/buttons/TabButton/index.js';
import '../../../../ui/buttons/TabButtonV2/index.js';
import '../../../../ui/buttons/TimerButton/index.js';
import '../../../../ui/buttons/TimerButtonV2/index.js';
import '../../../../ui/buttons/TimerButtonV3/index.js';
import '../../../../ui/loaders/Loader/index.js';
import '../../../../ui/loaders/ScreenLoader/index.js';
import '../../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../../ui/modals/Modal/Modal.js';
import '../../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../../ui/popups/Popper/index.js';
import '../../../../ui/popups/Popup/BasePopup/index.js';
import '../../../../ui/popups/Popup/Thumb/index.js';
import '../../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../../ui/sliders/EmblaCarousel/index.js';
import '../../../../ui/tables/Table/index.js';
import '../../../../ui/tables/Table/TableTd/index.js';
import '../../../../ui/tabs/Tabs/index.js';
import '../../../../ui/tabs/TabsV2/index.js';
import '../../../../ui/texts/CryptoValue/index.js';
import '../../../../ui/texts/AmountValue/index.js';
import '../../../../ui/texts/TitleWithCurrency/index.js';
import '../../../../ui/texts/Text/index.js';
import '../../../../ui/texts/TextNavigation/index.js';
import '../../../../ui/texts/MinValue/index.js';
import '../../../../ui/socials/SocialsList/index.js';

const UserInfoUser = ({
  data,
  onShare,
  onTipClick,
  text
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  UserInfo,
  {
    ...data,
    bigIcon: true,
    canShareProfile: true,
    showRank: false,
    onShare,
    type: "v2",
    text
  }
), onTipClick ? /* @__PURE__ */ React.createElement(
  GradientButton,
  {
    text: "Tip",
    kind: "fill",
    size: "md-2",
    onClick: onTipClick,
    animated: false
  }
) : null);
UserInfoUser.displayName = "UserInfoModal.UserInfoUser";

export { UserInfoUser };
//# sourceMappingURL=index.js.map
